import {
  REQUEST_LOGISTIC_ROUTES,
  RESPONSE_LOGISTIC_ROUTES,
  REQUEST_LOGISTIC_ROUTES_FAILURE,
  REQUEST_LOGISTIC_ROUTE,
  RESPONSE_LOGISTIC_ROUTE,
  REQUEST_LOGISTIC_ROUTE_FAILURE,
  REQUEST_CREATE_LOGISTIC_ROUTE,
  RESPONSE_CREATE_LOGISTIC_ROUTE,
  REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE,
  REQUEST_DELETE_LOGISTIC_ROUTE,
  RESPONSE_DELETE_LOGISTIC_ROUTE,
  REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE,
  REQUEST_UPDATE_LOGISTIC_ROUTE,
  RESPONSE_UPDATE_LOGISTIC_ROUTE,
  REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE,
  ON_SELECT_LOGISTIC_ROUTE,
  REQUEST_ADD_CONTROL_POINT_ROUTE,
  RESPONSE_ADD_CONTROL_POINT_ROUTE,
  REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE,
  REQUEST_DELETE_CONTROL_POINT_ROUTE,
  RESPONSE_DELETE_CONTROL_POINT_ROUTE,
  REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE,
  REQUEST_LOGISTIC_ROUTE_GEOJSON,
  RESPONSE_LOGISTIC_ROUTE_GEOJSON,
  REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE,
  REQUEST_SETNUMBER_CONTROL_POINT_ROUTE,
  RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE,
  REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE,
} from "../actions/logisticRoutesActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticRoutesDataState: queriesStates.NOT_REQUESTED,
  logisticRouteDataState: queriesStates.NOT_REQUESTED,
  logisticRouteGeoJsonDataState: queriesStates.NOT_REQUESTED,
  logisticCreateRoutesDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteRoutesDataState: queriesStates.NOT_REQUESTED,
  logisticUpdateRoutesDataState: queriesStates.NOT_REQUESTED,
  logisticAddControlPointRouteDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteControlPointRouteDataState: queriesStates.NOT_REQUESTED,
  logisticSetNumberControlPointRouteDataState: queriesStates.NOT_REQUESTED,
  logisticSelectedRoute: null,
  logisticRoutes: [],
  errors: [],
};

const logisticRoutesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGISTIC_ROUTES: {
      return Object.assign({}, state, {
        logisticRoutesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_ROUTES: {
      return Object.assign({}, state, {
        logisticRoutesDataState: queriesStates.READY,
        logisticRoutes: action.data.routes,
      });
    }
    case REQUEST_LOGISTIC_ROUTES_FAILURE: {
      return Object.assign({}, state, {
        logisticRoutesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticRouteDataState: queriesStates.READY,
        logisticSelectedRoute: action.data,
      });
    }
    case REQUEST_LOGISTIC_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticCreateRoutesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticCreateRoutesDataState: queriesStates.READY,
        logisticRoutes: state.logisticRoutes.concat(action.data),
        logisticSelectedRoute: action.data,
      });
    }
    case REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticCreateRoutesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticDeleteRoutesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticDeleteRoutesDataState: queriesStates.READY,
        logisticRoutes: state.logisticRoutes.filter((x) => {
          return x.id !== action.data.id;
        }),
        logisticSelectedRoute: null,
      });
    }
    case REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteRoutesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case ON_SELECT_LOGISTIC_ROUTE: {
      const _route = Object.assign({}, action.data, {});

      return Object.assign({}, state, {
        logisticSelectedRoute: _route,
      });
    }

    case REQUEST_UPDATE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticUpdateRoutesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_UPDATE_LOGISTIC_ROUTE: {
      return Object.assign({}, state, {
        logisticUpdateRoutesDataState: queriesStates.READY,
        logisticSelectedRoute: action.data,
      });
    }
    case REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticUpdateRoutesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_ADD_CONTROL_POINT_ROUTE: {
      return Object.assign({}, state, {
        logisticAddControlPointRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_ADD_CONTROL_POINT_ROUTE: {
      const logisticSelectedRoute = state.logisticSelectedRoute;

      logisticSelectedRoute.controlPoints = logisticSelectedRoute.controlPoints.concat([action.data]);
      const length = logisticSelectedRoute.controlPoints.length;
      logisticSelectedRoute.controlPoints[length - 1].number = length;

      return Object.assign({}, state, {
        logisticAddControlPointRouteDataState: queriesStates.READY,
        logisticSelectedRoute: logisticSelectedRoute,
      });
    }
    case REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticAddControlPointRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_CONTROL_POINT_ROUTE: {
      return Object.assign({}, state, {
        logisticDeleteControlPointRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_CONTROL_POINT_ROUTE: {
      const _logisticSelectedRoute = state.logisticSelectedRoute;

      _logisticSelectedRoute.controlPoints = _logisticSelectedRoute.controlPoints.filter((x) => {
        return x.id !== action.controlPointId;
      });

      return Object.assign({}, state, {
        logisticDeleteControlPointRouteDataState: queriesStates.READY,
        logisticSelectedRoute: _logisticSelectedRoute,
      });
    }
    case REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteControlPointRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_LOGISTIC_ROUTE_GEOJSON: {
      return Object.assign({}, state, {
        logisticRouteGeoJsonDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_ROUTE_GEOJSON: {
      const logisticSelectedRoute = state.logisticSelectedRoute;
      logisticSelectedRoute.geojsonData = action.data;

      return Object.assign({}, state, {
        logisticRouteGeoJsonDataState: queriesStates.READY,
        logisticSelectedRoute: logisticSelectedRoute,
      });
    }
    case REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE: {
      return Object.assign({}, state, {
        logisticRouteGeoJsonDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_SETNUMBER_CONTROL_POINT_ROUTE: {
      return Object.assign({}, state, {
        logisticSetNumberControlPointRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE: {
      const __logisticSelectedRoute = state.logisticSelectedRoute;
      __logisticSelectedRoute.controlPoints = action.data.controlPoints;
      __logisticSelectedRoute.geojsonData = null;
      
      return Object.assign({}, state, {
        logisticSetNumberControlPointRouteDataState: queriesStates.READY,
        logisticSelectedRoute: __logisticSelectedRoute,
      });
    }
    case REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        logisticSetNumberControlPointRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default logisticRoutesReducer;
